import { useCurrentWorkspace, useStorageKeys } from '@gripp/shared-logic';
import {
  AlertsButton,
  AssetSearchInput,
  AssetsList,
  EntityAlertListModal,
  FilterType,
  SelectionStatus,
} from '@gripp/shared-ui';
import { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { FilterBar } from '../../shared/components/filter/filterBar';
import { useMaxHeight } from '../../shared/hooks/useMaxHeight';
import { AssetGroups } from './assetGroups';
import { RoutinesButton } from './routinesButton';

export const Assets = () => {
  const navigate = useNavigate();
  const workspace = useCurrentWorkspace(true);
  const storageKeys = useStorageKeys();
  const { containerMaxHeight, listMaxHeight } = useMaxHeight(64, 0, 228);
  const [selectionStatus, setSelectionStatus] =
    useState<SelectionStatus>('idle');

  const [rowsSelected, setRowsSelected] = useState<Array<any>>([]);
  const [showAlertListModal, setShowAlertListModal] = useState(false);
  const [selectedAssetIdForAlert, setSelectedAssetIdForAlert] = useState<
    string | undefined
  >(undefined);

  const onAssetClick = (asset: { id: string }) => {
    navigate(`/assets/${asset.id}`);
  };

  const updateRowsSelected = (rows: Array<any>) => {
    setRowsSelected(rows.map(row => row.id));
  };

  const resetRowSelection = () => {
    updateRowsSelected([]);
    setSelectionStatus('reset');
  };

  const AddToGroups = () => (
    <View style={styles.addToGroupsContainer}>
      <AssetGroups
        assetIds={rowsSelected || []}
        workspaceId={workspace?.id || ''}
        onUpdateRowSelected={resetRowSelection}
      />
    </View>
  );

  return (
    <>
      <View style={styles.filtersContainer}>
        <View style={styles.assetSearchContainer}>
          <AssetSearchInput />
        </View>
        <FilterBar
          filterButtonTypes={[FilterType.ASSETGROUPS, FilterType.ASSETCOLUMNS]}
        />
      </View>
      <View
        style={[
          styles.assetsContainer,
          {
            maxHeight: containerMaxHeight,
          },
        ]}
      >
        <AssetsList
          onAssetClick={onAssetClick}
          maxHeight={listMaxHeight}
          updateRowsSelected={updateRowsSelected}
          preserveScrollKey={storageKeys.assetsScrollData}
          addToGroupsComponent={AddToGroups()}
          selectionStatus={selectionStatus}
          onSelectionStatusChange={(status) => setSelectionStatus(status)}
          routinesButton={RoutinesButton}
          alertsButton={(data) => (
            <AlertsButton
              alertsCount={data.alertsCount}
              assetId={data.assetId}
              name={data.name}
              onPress={() => {
                setSelectedAssetIdForAlert(data.assetId);
                setShowAlertListModal(true);
              }}
            />
          )}
        />
      </View>
      {showAlertListModal && selectedAssetIdForAlert && (
        <EntityAlertListModal
          visible={showAlertListModal}
          entityType="asset"
          entityId={selectedAssetIdForAlert}
          onClose={() => {
            setShowAlertListModal(false);
            setSelectedAssetIdForAlert(undefined);
          }}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  filtersContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: 44,
    marginBottom: 20,
  },
  assetSearchContainer: {
    width: 390, // current minimum size needed to avoid placeholder clipping on web
    marginRight: 20,
  },
  addToGroupsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  assetsContainer: {
    flex: 1,
    borderRadius: 8,
    overflow: 'hidden',
    zIndex: -1,
  },
});
